import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const NinetyNine: React.FC = () => {
    return (
        <Layout>
            <div>
                <p><Link to="/">top</Link></p>
                99戦
            </div>
        </Layout>
    );
}

export default NinetyNine;
